<template lang="pug">
GenericCard.overall-stat-panel(size='80')
  .d-flex.justify-content-between.px-4.mx-3.pt-4.pb-3
    .text-title สถิติการขายสินค้าตามเขต
    AreaSelector(v-model='filterArea')
  hr.m-0
  .d-flex.justify-content-center.px-4.py-3.mt-1
    template(v-if="!isLoading")
      div.d-flex.flex-column
        .text-large.px-3
          | กลุ่มสินค้าขายดีตามจำนวน
        GenericCard.px-3.flex-fill.scrollable(size='36')
          div(style='max-height: 70vh')
            //- img.w-100.py-4.px-2(src='@/assets/_mock/graph.svg')
            GraphBestSellingProductGroup.mt-3(:groupsData="bestSellingsAmountGroupRatio")
            CustomTable.px-2(
              :columns='bestSellingsAmountTableColumns'
              :data='bestSellingsAmountTableData'
              @itemClicked='bestSellingClicked'
            )
      div.d-flex.flex-column
        .text-large.px-3
          | กลุ่มสินค้าขายดีตามยอดสั่งซื้อ
        GenericCard.px-3.flex-fill.scrollable(size='36')
          div(style='max-height: 70vh')
            //- img.w-100.py-4.px-2(src='@/assets/_mock/graph.svg')
            GraphBestSellingProductGroup.mt-3(:groupsData="bestSellingsTotalGroupRatio")
            CustomTable.px-2(
              :columns='bestSellingsTotalTableColumns'
              :data='bestSellingsTotalTableData'
              @itemClicked='bestSellingClicked'
            )
    .text-center(v-else): .spinner-border
    //- div.d-flex.flex-column.pl-2
    //-   .text-large ลูกค้าที่มียอดซื้อสะสมสูงสุด
    //-   GenericCard.pl-0.pr-0.flex-fill(size='27')
    //-     div(style='max-height: 75vh')
    //-       template(v-for='i in [0,1,2,3,4,5,6,7,8,9,10]')
    //-         CustomerShortDetailButton(:data='MOCK_CUSTOMER')

</template>

<script>
import ProfilePerformanceStatItem from '@/components/profile-performance/ProfilePerformanceStatItem.vue';
import GraphBestSellingProductGroup from '@/components/GraphBestSellingProductGroup.vue';
import CustomerShortDetailButton from '@/components/profile-performance/CustomerShortDetailButton.vue';

import ProductGroupStat from '@/components/history/dialogs/BestSellings/ProductGroupStat.vue';

import AreaSelector from './AreaSelector.vue';

export default {
  props: {
    seller: {
      default: () => ({}),
    },
  },
  data: () => ({
    daily: {
      commission: 31670.00,
      sales: 55123.00,
    },
    MOCK_CUSTOMER: {
      name: 'บริษัท ซาฟารีเวิลด์ จำกัด (มหาชน)',
      total: '3,1670.00',
    },

    bestSellingsAmountTableData: [],
    bestSellingsAmountTableColumns: {
      name: { title: 'กลุ่ม - ชื่อ', align: 'left' },
      amount: { title: 'จำนวนรวม', align: 'right', type: 'PRODUCT_AMOUNT' },
    },
    bestSellingsAmountGroupRatio: [],

    bestSellingsTotalTableData: [],
    bestSellingsTotalTableColumns: {
      name: { title: 'กลุ่ม - ชื่อ', align: 'left' },
      total: { title: 'ยอดรวม', align: 'right', type: Number },
    },
    bestSellingsTotalGroupRatio: [],

    selectedProductGroup: [],
    selectedProductGroupIndex: -1,

    isLoading: false,

    filterArea: '',
  }),
  watch: {
    filterArea(newVal) {
      if (newVal !== null) this.loadData();
    },
  },
  methods: {
    // async loadData() {
    //   this.isLoading = true;

    //   const res = await this.$api.user.bestSellingsList();
    //   if (res.status === 200) {
    //     this.bestSellingsTotalTableData = res.data.data;
    //   }

    //   const resProductGroup = await this.$api.user.bestSellingsTotalGroupRatio();
    //   if (res.status === 200) {
    //     this.bestSellingsTotalGroupRatio = resProductGroup.data.data;
    //   }

    //   this.isLoading = false;
    // },
    async loadData() {
      this.isLoading = true;
      const resbestSellers = await this.$api.admin.sellerRecords.bestSellers(this.filterArea);
      if (resbestSellers.status === 200) {
        const byGroup = {};

        resbestSellers.data.forEach((elm) => {
          const strPad = `00${elm.group_id}`;
          const groupName = strPad.substring(strPad.length - 2, strPad.length);
          if (!(groupName in byGroup)) byGroup[groupName] = [];
          byGroup[groupName].push(elm);
        });

        console.log(byGroup);

        // const sorted = []; //

        const byGroupTable = [];

        Object.keys(byGroup).forEach((key) => {
          const obj = {
            group_id: key,
            name: key,
            total: 0,
            amount: 0,
          }; // TODO: find group name
          byGroup[key].forEach((elm) => {
            obj.name = `${key} - ${elm.group_name}`;
            obj.total += parseFloat(elm.total);
            obj.amount += Number(elm.amount);
          });
          byGroupTable.push(obj);
        });

        this.bestSellingsAmountTableData = [...byGroupTable].sort((a, b) => b.amount - a.amount);
        this.bestSellingsTotalTableData = byGroupTable.sort((a, b) => b.total - a.total);

        // let wholeTotal = 0;
        // byGroupTable.forEach((elm) => { wholeTotal += elm.total; });

        this.bestSellingsAmountGroupRatio = byGroupTable.map(elm => ({
          group: elm.group_id,
          value: elm.amount,
        }));
        this.bestSellingsTotalGroupRatio = byGroupTable.map(elm => ({
          group: elm.group_id,
          value: elm.total,
        }));

        this.isLoading = false;
      }
      // const res = await this.$api.user.bestSellingsList();
      // if (res.status === 200) {
      //   this.bestSellingsTotalTableData = res.data.data;
      // }

      // const resProductGroup = await this.$api.user.bestSellingsTotalGroupRatio();
      // if (res.status === 200) {
      //   this.bestSellingsTotalGroupRatio = resProductGroup.data.data;
      // }
    },
    bestSellingClicked(e) {
      this.selectedProductGroup = e.data;
      this.selectedProductGroupIndex = e.index;
      this.$modal.show('product-group-stat');
    },
    hideModal() {
      // console.log('close');
      this.$modal.hide('product-group-stat');
    },
  },
  components: {
    ProfilePerformanceStatItem,
    CustomerShortDetailButton,
    ProductGroupStat,
    GraphBestSellingProductGroup,

    AreaSelector,
  },
};
</script>

<style lang="scss">
// .overall-stat-panel {}
</style>
